export default theme => ({
  draggingElement: {
    zIndex: "100",
    cursor: "move",
  },
  element: {
    position: "relative",
  },
});
